import { Link } from "react-router-dom";
import { Star, MapPin, Heart, ShieldCheck } from "lucide-react";
import { bannerFor, TYPE_LABEL } from "./ListingCard";

export default function FeaturedCard({ inst }) {
  return (
    <Link to={`/institutes/${inst.id}`} data-testid={`featured-card-${inst.id}`}
      className="featured-card snap-start shrink-0 w-[46%] sm:w-56 md:w-auto nb bg-white overflow-hidden flex flex-col" style={{ borderRadius: 16 }}>
      <div className="relative h-24 sm:h-32 border-b-2 border-[#171B33]">
        <img src={bannerFor(inst)} alt={inst.name} className="w-full h-full object-cover" />
        <span className="absolute bottom-2 left-2 nb-badge bg-white" style={{ padding: "2px 8px", fontSize: 11 }}>
          <Star className="w-3 h-3 fill-amber-400 text-amber-400" /> {inst.avg_rating || "—"}
        </span>
        {inst.badge === "verified" && <span className="absolute top-2 left-2 nb-badge" style={{ background: "#93C5FD", padding: "2px 6px", fontSize: 10 }}><ShieldCheck className="w-3 h-3" /></span>}
        <span className="featured-heart absolute top-2 right-2 w-7 h-7 rounded-full bg-white border-2 border-[#171B33] flex items-center justify-center"><Heart className="w-3.5 h-3.5" /></span>
      </div>
      <div className="p-3 flex-1 flex flex-col">
        <p className="font-display font-extrabold text-sm leading-tight line-clamp-1">{inst.name}</p>
        <p className="text-[11px] text-slate-500 mt-1 line-clamp-1">{(inst.exams || []).length ? inst.exams.join(" | ") : TYPE_LABEL[inst.type] || "Coaching"}</p>
        <p className="text-[11px] text-slate-500 mt-0.5 flex items-center gap-1 line-clamp-1"><MapPin className="w-3 h-3" /> {inst.area}, {inst.city}</p>
        <span className="mt-2 text-center text-xs font-bold py-1.5 rounded-lg border-2 border-[#171B33]" style={{ background: "#F2FBE3" }}>View Details →</span>
      </div>
    </Link>
  );
}
